import React from "react";
import { Box } from "@mui/material";

const SectionHeader = ({ children, variant = "primary" }) => {
  const styles = {
    primary: {
      fontSize: "18px",
      fontWeight: 600,
    },
    secondary: {
      fontSize: "16px",
      fontWeight: 600,
    }
  };

  return (
    <Box sx={{
      backgroundColor: "#F3F5F7",
      padding: "12px 16px",
      borderRadius: "6px",
      marginBottom: "16px",
      marginLeft: "-30px",
      marginRight: "-30px",
      paddingLeft: "46px",
      paddingRight: "46px"
    }}>
      <Box component={variant === "primary" ? "h3" : "h4"} sx={{
        ...styles[variant],
        margin: 0,
        color: "#1A1E24"
      }}>
        {children}
      </Box>
    </Box>
  );
};

export default SectionHeader;
